module.exports = __webpack_public_path__ + "static/media/people.d7affc69.csv";